import { DataGrid } from "@mui/x-data-grid";
import { dataGridStyle } from "../../../../theme";
import { useEffect, useState } from 'react';
import API from '../../../../api';

const TicketHistory = () => {
  const [tickets, setTickets] = useState([]);
  const [charged, setCharged] = useState(false)

  useEffect(() => {
    API.getHistoryTickets({})
      .then((result) => {
        const transformedData = result.data.map((item) => ({
          id: item._id,
          ...item,
        }));
        setTickets(transformedData);
        setCharged(true);
      })
      .catch((error) => {
        console.error(
          "Si è verificato un errore durante il recupero dei dati",
          error
        );
        setCharged(true);
      });
  }, []);
  const columns = [
    { field: "dataCreazione", headerName: "Creation Date", width: 160, headerAlign: "center", align: "center", },
    { field: "oggetto", headerName: "Subject", width: 150, headerAlign: "center", align: "center", },
    { field: "stato", headerName: "State", width: 100, headerAlign: "center", align: "center",  renderCell: (params) => {
      return params.value === 1 ? "Send" : params.value===2 ?  "Open": "Close";
    }, },
    { field: "messaggio", headerName: "Message", flex:1, headerAlign: "center", align: "center", },
  ];

  return (
    <>
        <DataGrid rows={tickets} columns={columns} loading={!charged}        
        sx={dataGridStyle}/>

    </>
  );
};
export default TicketHistory;
